export const VUE_SCROLL_OPTION = {
  rail: {
    background: '#fff',
    gutterOfSide: '0px',
    size: '4px'
  },
  bar: {
    background: '#3897FF',
    keepShow: false,
    hoverStyle: true,
    onlyShowBarOnScroll: false,
    specifyBorderRadius: '0',
    size: '4px',
    minSize: 0.2,
    opacity: 1
  },
  scrollButton: {
    enable: false,
    background: '#3897FF'
  },
  scrollPanel: {
    easing: 'easeInQuad',
    speed: 800
  },
  vuescroll: {
    wheelScrollDuration: 0,
    wheelDirectionReverse: false
  }
}

export const  BATCH_COLOR = [
  {name:'1st batch',color:'#faa800'},
  {name:'2nd batch',color:'#477fff'},
  {name:'3rd batch',color:'#0fede1'},
  {name:'4th batch',color:'#3eb5ff'},
  {name:'5th batch',color:'#9200ff'},
  {name:'6th batch',color:'#3447ff'}
]